import script from "./HomeGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeGroup.vue?vue&type=script&setup=true&lang=js"

import "./HomeGroup.vue?vue&type=style&index=0&id=3db682ff&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db682ff"]])

export default __exports__